import { render, staticRenderFns } from "./ScoreTrendWidget.vue?vue&type=template&id=421941ef"
import script from "./ScoreTrendWidget.vue?vue&type=script&lang=js"
export * from "./ScoreTrendWidget.vue?vue&type=script&lang=js"
import style0 from "./ScoreTrendWidget.vue?vue&type=style&index=0&id=421941ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports